import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';

export function getOpenJobs(jobStatusId, pageSize, page, fromLoadMore, sortBy, queryParams) {
  console.log('getOpenJobs ');
  return (dispatch) => {
    let url = API_END_POINTS.GET_OPEN_JOB_CATEGORIES + '?jobstate=' + jobStatusId + '&limit=' + pageSize + '&offset=' + page;
    if (sortBy) {
      url = url + '&' + sortBy;
    }
    if (queryParams) {
      url = url + queryParams;
    }
    axios.get(url)
      .then((response) => {
        if (response.status == 200 || response.status == 304 && response.data) {
          console.log('Response ', response.data);
          dispatch({
            type: types.GET_OPEN_JOB_CATEGORIES,
            openJobCategoryList: response.data.data,
            jobStatusId: jobStatusId,
            currentPage: page,
            pageInfo: response.data.pageInfo,
            fromLoadMore: fromLoadMore
          });
        } else {
          dispatch({
            type: types.GET_OPEN_JOB_CATEGORIES,
            currentPage: page,
            pageInfo: response.data.pageInfo,
            fromLoadMore: fromLoadMore,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_OPEN_JOB_CATEGORIES,
            currentPage: page,
            pageInfo: {},
            fromLoadMore: fromLoadMore,
            unableToFetch: true
          });
        }
      });
  };
}

export function getPostedJobById(jobID, jobStatus) {
  console.log('Get Posted Job by id');
  return (dispatch) => {
    axios.get(`${API_END_POINTS.GET_POSTED_JOB}/${jobID}` + '?imageflow=1')
      .then((response) => {
        if (response.status == 200 && response.data) {
          if (response.data && !response.data.alreadySeen && response.data.requeststatus && response.data.requeststatus && (response.data.requeststatus.name == 'Waiting')) {
            response.data.alreadySeen = true;
            dispatch({
              type: types.UPDATE_NEW_COUNT
            });
          }
          dispatch({
            type: types.GET_POSTED_JOB_BY_ID,
            jobDetails: response.data,
            jobStatus: jobStatus
          });
        } else {
          dispatch({
            type: types.GET_POSTED_JOB_BY_ID,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_POSTED_JOB_BY_ID,
            unableToFetch: true
          });
        }
      });
  };
}

export function updateNewCount(jobId) {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_NEW_COUNT
    });
    dispatch({
      type: types.UPDATE_NEW_COUNT_FOR_JOB_ID,
      jobId: jobId
    });
  }
}
export function getJobServicesStatus() {
  return (dispatch) => {
    axios.get(API_END_POINTS.GET_JOB_SERVICE_STATUSES)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_JOB_SERVICE_STATUSES,
            jobServiceStatuses: response.data
          });
        }
      });
  };
}

export function declineAJob(jobID, currentJobStatus, declineReason) {
  return (dispatch) => {
    const DECLINE_A_JOB_END_POINT = API_END_POINTS.DECLINE_A_JOB.replace('${userbookingrequest-id}', jobID);
    axios.post(DECLINE_A_JOB_END_POINT, {declineReason: declineReason ? declineReason : ''})
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.DECLINE_A_JOB,
            jobDeclined: response.data,
            jobID: jobID
          });
          dispatch({
            type: types.CHANGE_STATUS_OF_SIDEBAR_COUNT,
            changeJobStatusTo: 'decline',
            currentJobStatus: currentJobStatus
          });
          dispatch({
            type: types.UPDATE_JOB_STATUS,
            jobID: jobID,
            nextJobStatus: 'decline',
            currentJobStatus: currentJobStatus
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: `Job has been declined`,
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message ? response.data.message : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response.data && err.response.data.message ? err.response.data.message : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}


export function getJobHistory(jobStatusId, pageSize, page, fromLoadMore, sortBy, queryParams) {
  return (dispatch) => {
    let url = API_END_POINTS.GET_OPEN_JOB_CATEGORIES + '?jobstate=' + jobStatusId + '&limit=' + pageSize + '&offset=' + page;
    if (sortBy) {
      url = url + '&' + sortBy;
    }
    if (queryParams) {
      url = url + queryParams;
    }
    axios.get(url)
      .then((response) => {
        if (response.status == 200 && response.data) {
          dispatch({
            type: types.GET_JOB_HISTORY,
            jobHistoryList: response.data.data,
            jobStatusId: jobStatusId,
            currentPage: page,
            pageInfo: response.data.pageInfo,
            fromLoadMore: fromLoadMore
          });
        } else {
          dispatch({
            type: types.GET_JOB_HISTORY,
            currentPage: page,
            jobStatusId: jobStatusId,
            pageInfo: response.data.pageInfo,
            fromLoadMore: fromLoadMore,
            unableToFetch: true
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.GET_JOB_HISTORY,
            currentPage: page,
            jobStatusId: jobStatusId,
            pageInfo: {},
            fromLoadMore: fromLoadMore,
            unableToFetch: true
          });
        }
      });
  };
}


export function createQuote(quoteData, jobStatus, isEndDateTime, isQuoteNoteUpdated) {
  console.log('Going to create a quote --->', quoteData);
  return (dispatch) => {
          axios.post(`${API_END_POINTS.SEND_QUOTE}`, quoteData)
          .then((response) => {
            if (response.status === 200) {
              console.log('Success on send quote');
              if (isEndDateTime) {
                dispatch({
                  type: types.SHOW_TOAST_MESSAGE,
                  toastMessage: 'Job end date and time has been updated',
                  toastType: 'success'
                });
              }
              else if (isQuoteNoteUpdated) {
                dispatch({
                  type: types.SHOW_TOAST_MESSAGE,
                  toastMessage: 'Job note has been updated',
                  toastType: 'success'
                });
                dispatch({
                  type: types.UPDATE_JOB_QUOTE_NOTE,
                  jobData: response.data,
                  jobID: quoteData.userbookingrequestid
                });
              }
              else {
                axios.get(`${API_END_POINTS.GET_POSTED_JOB}/${response.data.id}` + '?imageflow=1')
                  .then((response) => {
                    if (response.status == 200 && response.data) {
                      if (jobStatus == 'waiting') {
                        dispatch({
                          type: types.CHANGE_STATUS_OF_SIDEBAR_COUNT,
                          changeJobStatusTo: 'applied'
                        });
                      }
                      dispatch({
                        type: types.SHOW_TOAST_MESSAGE,
                        toastMessage: `Job has been ${((jobStatus == 'waiting') ? 'created' : 'updated')}`,
                        toastType: 'success'
                      });
                      dispatch({
                        type: types.GET_POSTED_JOB_BY_ID,
                        jobDetails: response.data,
                        jobStatus: response.data.garagejobquote.jobdetailstatus.displayname,
                        replaceWaitingWithApplied: jobStatus == 'waiting' ? true : false
                      });
                    } else {
                      dispatch({
                        type: types.GET_POSTED_JOB_BY_ID,
                        unableToFetch: true
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.config) {
                      dispatch({
                        type: types.GET_POSTED_JOB_BY_ID,
                        unableToFetch: true
                      });
                    }
                  });
              }
            } else {
              dispatch({
                type: types.GET_POSTED_JOB_BY_ID,
                unableToFetch: true
              })
              dispatch({
                type: types.SHOW_TOAST_MESSAGE,
                toastMessage: 'Unknown error occurred please try again',
                toastType: 'error'
              })
            }
          })
          .catch((err) => {
            if (err.config) {
              dispatch({
                type: types.GET_POSTED_JOB_BY_ID,
                unableToFetch: true
              })
              dispatch({
                type: types.SHOW_TOAST_MESSAGE,
                toastMessage: err.response.data && err.response.data.err ? err.response.data.err : 'Unknown error occurred please try again',
                toastType: 'error'
              });
            }
          });
  };
}

export function updateJobStatus(jobID, jobObj) {
  return (dispatch) => {
    const UPDATE_JOB_STATUS_END_POINT = API_END_POINTS.UPDATE_JOB_STATUS.replace('${userbookingrequest-id}', jobID);
    axios.post(UPDATE_JOB_STATUS_END_POINT, jobObj)
      .then((response) => {
        if (response.status == 200) {
          const currentJobStatus = jobObj.currentJobStatus ? (jobObj.currentJobStatus == 'inprogress') ? 'In Progress' : jobObj.currentJobStatus == 'completed' ? 'Completed' : jobObj.currentJobStatus : null;
          if (jobObj.nextJobStatus && currentJobStatus && (jobObj.nextJobStatus != currentJobStatus)) {
            dispatch({
              type: types.CHANGE_STATUS_OF_SIDEBAR_COUNT,
              changeJobStatusTo: jobObj.nextJobStatus,
              currentJobStatus: currentJobStatus
            });
          }
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Service status has been updated',
            toastType: 'success'
          });
          dispatch({
            type: types.UPDATE_JOB_STATUS,
            jobID: jobID,
            nextJobStatus: jobObj.nextJobStatus,
            currentJobStatus: currentJobStatus,
            updatedQuotesList: jobObj.updatedQuotesList
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data && response.data.message ? response.data.message : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function setServiceKms(kmsData, requestId) {
  return (dispatch) => {
    axios.post(API_END_POINTS.SERVICED_KMS, kmsData)
      .then((response) => {
        if (response.status == 200) {
          // dispatch({
          //   type: types.SET_SERVICED_KMS,
          //   kms: kmsData.kms,
          //   requestId: requestId
          // });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Serviced kms has been updated',
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      })
      .catch((err) => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Unknown error occurred please try again',
            toastType: 'error'
          });
        }
      });
  }
}

export function getManufacturers() {
  return (dispatch) => {

    axios.get(API_END_POINTS.GET_CAR_MANUFACTURERS, { withCredentials: true })
      .then((response) => {
        if (response.status == 200) {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            manufacturers: response.data,
            responseType: 'make',
            unableToFetch: false,
          });
        } else {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            unableToFetch: true,
          });
        }
      }).catch((err) => {
        if (err.config) {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            unableToFetch: true,
          });
        }
      });

  };
}

export function getCarModels(makeId) {
  return (dispatch) => {

    axios.get(API_END_POINTS.GET_CAR_MODELS + '?carmake=' + makeId, { withCredentials: true })
      .then((response) => {
        if (response.status == 200) {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            models: response.data,
            responseType: 'model',
            makeId: makeId,
            unableToFetch: false,
          });
        } else {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            unableToFetch: true,
            responseType: 'model',
            makeId: makeId
          });
        }
      }).catch((err) => {
        if (err.config) {
          dispatch({
            type: types.CAR_MAKE_AND_MODELS,
            unableToFetch: true,
            responseType: 'model',
            makeId: makeId
          });
        }
      });

  };
}

export function openJobsFilterChanged(filterState, type, isSort) {
  return (dispatch) => {
    dispatch({
      type: types.OPEN_JOBS_FILTER,
      filterState: filterState,
      openJobType: type,
      isSort: isSort
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/jobRequestActions.js